import { render, staticRenderFns } from "./homeLoan.vue?vue&type=template&id=28aad4c4&"
import script from "./homeLoan.vue?vue&type=script&lang=js&"
export * from "./homeLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports